<template>

  <div class="middle-box text-center loginscreen animated fadeInDown">

    <div class="image-logo">
      <img src="/static/img/logo-ssparisi.png" alt="Logo">
    </div>

    <h3 class="font-bold">Esqueci a Senha</h3>

    <div class="error-desc">
      Por favor informe o email registrado. Enviaremos uma mensagem com o link para você recriar a sua senha.
      <form class="m-t" role="form">

        <div class="form-group">
          <input type="email" name="email" class="form-control" placeholder="email@email.com"
          v-model="email" v-validate="'required|email'" :class="{ invalid: errors.has('email') }">
          <span class="error">{{ errors.first('email') }}</span>
        </div>

        <button class="btn btn-success btn-block" @click.prevent="retrievePassword()"> Enviar </button>

      </form>

      <br />

      <a href="#" @click.prevent="$router.go(-1)">Voltar</a>

    </div>

    <p class="m-t"><small>SS PARISI todos direitos reservados &copy; {{ year }}</small></p>

  </div>

</template>

<script>

  import { httpService } from '../providers/http-service'
  import { toast } from '../mixins/toast'

  export default {
    mixins: [ toast ],
    data() {
      return {
        email: '',
        year: new Date().getFullYear()
      }
    },
    methods: {
      retrievePassword() {
        this.$validator.validateAll().then((valid) => {
          if(valid) {
            httpService.forgotPassword({ email: this.email }).then((res) => {
              if(res.status === 200) {
                if(res.data.error) {
                  this.show_toast('error', 'Ops!', res.data.msg)
                } else {
                  this.show_toast('success', 'Email de recuperação enviado', 'Por favor, verifique sua caixa de entrada.')
                  this.email = ''
                  this.$validator.reset()
                }
              }
            }).catch((err) => {
              this.show_toast('error', 'Falha ao enviar email', 'Você digitou o email correto?')
            })
          } else {
            this.show_toast('warning', 'Atenção', 'Verifique novamente os campos informados!')
            this.$validator.validateAll()
          }
        })
      }
    }
  }
</script>

<style scoped>

  .image-logo { height: 200px; position: relative; }

  .image-logo img{
    display: block;
    max-width: 100%;
    position: absolute;
    bottom:0;
    left:50%;
    transform:translateX(-50%);
  }

</style>



// WEBPACK FOOTER //
// src/components/ForgotPasswordPage.vue